export const clearLocalCreatorPushSubscription = async (): Promise<void> => {
  if (
    typeof navigator === "undefined" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return;

    try {
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) await subscription.unsubscribe();
    } catch {
      // Continue clearing the worker capability if browser unsubscribe fails.
    }

    const worker =
      registration.active || registration.waiting || registration.installing;
    worker?.postMessage({ type: "FANXO_CLEAR_PUSH_CONFIG" });
  } catch {
    // Notification cleanup must never block sign-out or token-expiry handling.
  }
};
